import type { UploadResponse } from '@/types/upload'

export type AgentUploadParams = {
    file: File
    onProgress?: (progress: number) => void
    signal?: AbortSignal
}

export type AgentUploadConfig = {
    sizeLimit?: number
    accept?: string
}

export interface AgentUploadStrategy<TAgentParams = unknown> {
    getLimit(): Promise<number | undefined>
    getUploadConfig(): AgentUploadConfig
    upload(params: AgentUploadParams, agentParams?: TAgentParams): Promise<UploadResponse | undefined>
}

export const AgentUploadStrategy = Symbol('AgentUploadStrategy')
